// extracted by mini-css-extract-plugin
export default {"container":"container___rMEcC","house-info":"house-info___Hu0ky","historyContainer":"historyContainer___VhJX4"};